export type PrizmDropdownWidthT = 'fixed' | 'min' | 'auto';
